// extracted by mini-css-extract-plugin
export default {"li":"customDots_li__2YRKP","dot":"customDots_dot__VdoN7","active":"customDots_active__s33DG"};